/*
 * @Description: 
 * @Autor: jk
 * @Date: 2023-04-03 16:40:57
 * @LastEditors: jk
 * @LastEditTime: 2023-04-07 11:14:59
 */
/**
 * 加载服务地址
 */
import { bus } from '@/bus.js'//引入bus.js定义的空的Vue实例

export const ParseLayer = {
  data() {
    return {
    }
  },
  methods: {
    //解析影像地址
    ParseLayer(value) {
      let active = false
      let that = this
      let serviceType = value.url.match(/(\/wms)|(\/tms)|(\/wfs)|(\{z}\/\{x})|(\/arcgis)|(\/cog)|(\/pyTile)/gi)
      if (/sj3data/.test(value.url) && (/gwc/.test(value.url))) {//obs中切片地址，目前都是内网geoserver切出来的，直接去找参数即可
        let projStr = (value.url.match(/EPSG.*?(?=\/)/, ''))[0];
        let layerStr = (value.url.match(/gwc\/.*?(?=\/)/, ''))[0].replace('gwc/', '');
        let URL = `http://121.36.101.27:3000/geoserver/gwc/service/tms/1.0.0/${layerStr}@${projStr}@png`;
        serviceType = URL.match(/(\/wms)|(\/tms)|(\/wfs)|(\{z}\/\{x})|(\/arcgis)/ig);
      }
      else if (/sj3data/.test(value.url) && (/.tif/.test(value.url))) {  //存放的COG数据
        if (/\/cog\/yingxiang/.test(value.url) || /\/cog\/pyyingxiang/.test(value.url)) {
          serviceType = ["GeoTIFFThree"]
        }
        else if (/\/cog\/jieguo/.test(value.url) || /\/cog\/pyjieguo/.test(value.url)) {
          serviceType = ["GeoTIFFOne"]
        }
      }
      else {
        //匹配/tms,/wms,/wfs,{z}/{x},/arcgis
        serviceType = value.url.match(/(\/wms)|(\/tms)|(\/wfs)|(\{z}\/\{x})|(\/arcgis)|(\/cog)|(\/pyTile)|(jl1mall)/gi)
      }
      if (!active) {//2D
        switch (serviceType[0]) {
          case '/wms':
            this.lyrType = "Image";
            this.srcType = "ImageWMS";
            break;
          case '/tms':
            this.lyrType = "Tile";
            this.srcType = "XYZ";
            break;
          case '/wfs':
            this.lyrType = "lVector";
            this.srcType = "Vector";
            break;
          case '{z}/{x}':
            this.lyrType = "Tile";
            this.srcType = "XYZ";
            break;
          case '/arcgis':
            this.lyrType = "Tile";
            this.srcType = "TileArcGISRest";
            break;
          case 'GeoTIFFThree':
            this.lyrType = "GeoTIFFThree";
            this.srcType = "GeoTIFFThree";
            break;
          case 'GeoTIFFOne':
            this.lyrType = "GeoTIFFOne";
            this.srcType = "GeoTIFFOne";
            break;
          case '/pyTile':
            this.lyrType = 'pyTile'
            this.srcType = 'XYZ'
            break;
          case 'jl1mall':
            this.lyrType = 'Tile'
            this.srcType = 'XYZ'
            break;
          default:
            console.error("遇到其他类型服务，目前代码还没写。。");
            break;
        }

        value.mUrl = value.url;
        value.mTitle = value.title;
        value.mName = value.title;
        value.mVisible = true;
        value.mKey = value.key;
        value.lyrType = this.lyrType;
        value.srcType = this.srcType;
        value.mzIndex = value.zIndex;
      } 
      return value
    },
  },
  created() {
  }

}